import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { getCompaniesSearchAction, getCompaniesBySlugAction, getCompaniesProductionsAction } from './actions';
// eslint-disable-next-line import/named
import { getCompanies, getProductions } from '../../utils/API';

export function* fetchCompanies({ payload, serverCookies }) {
  try {
    const response = yield call(getCompanies, get(payload, 'query', {}), get(payload, 'pagination', {}), serverCookies);
    yield put(getCompaniesSearchAction.success(get(response, 'data')));
  } catch (err) {
    yield put(getCompaniesSearchAction.failure(err.message));
  } finally {
    yield put(getCompaniesSearchAction.fulfill());
  }
}

export function* fetchCompaniesBySlug({ payload, serverCookies }) {
  try {
    const response = yield call(
      getCompanies,
      {
        country_id: get(payload, 'country'),
        ...get(payload, 'query', {}),
      },
      {
        limit: 12,
        ...get(payload, 'pagination', {}),
      },
      serverCookies,
    );
    yield put(getCompaniesBySlugAction.success(get(response, 'data')));
  } catch (err) {
    yield put(getCompaniesBySlugAction.failure(err.message));
  } finally {
    yield put(getCompaniesBySlugAction.fulfill());
  }
}

export default function* companiesSaga() {
  yield takeLatest(getCompaniesSearchAction.TRIGGER, fetchCompanies);
  yield takeLatest(getCompaniesBySlugAction.TRIGGER, fetchCompaniesBySlug);
}
